// extracted by mini-css-extract-plugin
export var chevron = "_3a-2";
export var chevronCollapsed = "_3a-3";
export var collapsibleHeader = "_3a-1";
export var container = "_3a-0";